import Paper from '@mui/material/Paper'
import SubTabsBase from '../../2compounds/SubTabsBase'
import ListItemIcon from '@mui/material/ListItemIcon'
import GetAppIcon from '@mui/icons-material/GetApp';

const iconStyles = { minWidth: '40px' }
const primaryTypographyProps = { fontWeight: 700 }
const defaultMenuItems = [
    {label: 'Master Data', description: '', value: 0}
]

const DataExportSideMenu = ({selectedTabIndex, setSelectedTabIndex, menuItems = defaultMenuItems}) => {
    const listItemIcon = (
        <ListItemIcon sx={iconStyles}>
            <GetAppIcon />
        </ListItemIcon>
    )


    return(
        <Paper>
            <SubTabsBase menuItems={menuItems} selectedTabIndex={selectedTabIndex} setSelectedTabIndex={setSelectedTabIndex}
                         listItemIcon={listItemIcon} primaryTypographyProps={primaryTypographyProps}/>
        </Paper>
    )
}

export default DataExportSideMenu
